var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.5H8.5C8.77614 2.5 9 2.72386 9 3V6H10.5V3C10.5 1.89543 9.60457 1 8.5 1H3C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15H8.5C9.60457 15 10.5 14.1046 10.5 13V10H9V13C9 13.2761 8.77614 13.5 8.5 13.5H3C2.72386 13.5 2.5 13.2761 2.5 13V3C2.5 2.72386 2.72386 2.5 3 2.5Z",
    fill: "#173348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0303 4.96967C12.7374 4.67678 12.2626 4.67678 11.9697 4.96967C11.6768 5.26256 11.6768 5.73744 11.9697 6.03033L13.1893 7.25H7.5C7.08579 7.25 6.75 7.58579 6.75 8C6.75 8.41421 7.08579 8.75 7.5 8.75H13.1893L11.9697 9.96967C11.6768 10.2626 11.6768 10.7374 11.9697 11.0303C12.2626 11.3232 12.7374 11.3232 13.0303 11.0303L15.5657 8.49497C15.8391 8.22161 15.8391 7.77839 15.5657 7.50503L13.0303 4.96967Z",
    fill: "#173348"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1fb378676d0fdeed8e083d2a5ba06e71.svg";
export { ForwardRef as ReactComponent };